"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const FamilyOwned = createSVGIcon(
  <>
    <path d="M15.571 20H3V8.02L9.279 4l6.292 4.02z" fill="#BDBFAE" />
    <path
      d="M20.5 16.214H10.071V6.728l5.209-3.144 5.22 3.144z"
      stroke="#312921"
    />
  </>,
  "Family owned",
  {
    titleAccess: "Family Owned",
    viewBox: "0 0 24 24",
    fill: "none",
  }
);
